import React, { FC } from 'react'
import * as Styles from '../styles'

export const DateComponent: FC<{ dateToShow: number }> = ({ dateToShow }) => {

  const date = new Date(dateToShow)

  return (
    <Styles.AnswerText style={{ textAlign: 'center' }}>
      {dateToShow ? (
        <>
          {`${date.toLocaleDateString()}`}
          <br />
          {date.toLocaleTimeString()}
        </>
      ) : (
        '-'
      )}
    </Styles.AnswerText>
  )
}
